import { render, staticRenderFns } from "./ImportWatchlistModal.vue?vue&type=template&id=28948606&scoped=true"
import script from "./ImportWatchlistModal.vue?vue&type=script&lang=js"
export * from "./ImportWatchlistModal.vue?vue&type=script&lang=js"
import style0 from "./ImportWatchlistModal.vue?vue&type=style&index=0&id=28948606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28948606",
  null
  
)

export default component.exports